export class ProfileCardBinding {
  /** Optional name to be displayed next to profile picture. I.e. 'Chase Wilson' */
  public name = "@?";
  /** Image URL to be displayed in the profile. Will default to stick figure if none supplied. Rendered at 40x40px.*/
  public profileImgUrl = "@?";
  /** Optional status glyph which will displayed in bottom right corner of profileImg. Rendered at 15x15px.*/
  public profileStatusGlyph = "<?";
  /** Label of provided status glyph to be used in alt text. */
  public profileStatusLabel = "<?";
}
export class ProfileCardController {
  public profileImgUrl: string;
  public name: string;
  public profileStatusGlyph: string;
  public profileStatusLabel: string;

  private defaultProfileImg = "../ShellCommon/Controls/profile-card/assets/unknown_profile.png";

  constructor() {
    if (!this.profileImgUrl) {
      this.profileImgUrl = this.defaultProfileImg;
    }
  }
}
export const sdProfileCard: ng.IComponentOptions = {
  bindings: <any>new ProfileCardBinding(),
  controller: ProfileCardController,
  templateUrl: "../ShellCommon/Controls/profile-card/profile-card.html",
  transclude: true
};
